/** @format */

import { useEffect, useState } from "react";
import BasicChart from "./basic-chart";
import { api } from "services";
interface Item {
  count: number;
  game: string;
  name: string;
  pool_id: string;
}
export default function GamePoolChart(props: any) {
  const [data, setData] = useState<Item[]>(null);
  useEffect(() => {
    async function load() {
      let rs = await api.post("/operation/get-game-pool-report", {});
      setData(rs);
      return rs;
    }
    load();
  }, []);
  return (
    <div>
      <h1>Game pool chart</h1>
      {data && (
        <table className="">
          <thead className="bg-slate-400">
            <tr>
              <th className="px-2">Game</th>
              <th className="px-2">Pool</th>
              <th className="px-2">Pool Id</th>
              <th className="px-2">Total Play </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item: Item) => (
              <tr className="border-2">
                <td className="border-2">{item.game}</td>
                <td className="border-2">{item.name}</td>
                <td className="border-2">{item.pool_id}</td>
                <td className="border-2">{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
